import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

export const get_category = createAsyncThunk("product/get_category", async (_, { fulfillWithValue, rejectWithValue }) => {
  try {
    const { data } = await api.get("/home/get-categorys");
    // console.log(data)
    return fulfillWithValue(data);
  } catch (error) {
    if (process.env.NODE_ENV === "development") console.log(error.respone);
    return rejectWithValue(error);
  }
});
// End Method

export const get_typeproduct = createAsyncThunk("product/get_typeproduct", async (_, { fulfillWithValue, rejectWithValue }) => {
  try {
    const { data } = await api.get("/home/get-typeproducts");
    // console.log(data)
    return fulfillWithValue(data);
  } catch (error) {
    if (process.env.NODE_ENV === "development") console.log(error.respone);
    return rejectWithValue(error);
  }
});
// End Method

export const get_typearticle = createAsyncThunk("product/get_typearticle", async (_, { fulfillWithValue, rejectWithValue }) => {
  try {
    const { data } = await api.get("/home/get-typearticles");
    // console.log(data)
    return fulfillWithValue(data);
  } catch (error) {
    if (process.env.NODE_ENV === "development") console.log(error.respone);
    return rejectWithValue(error);
  }
});
// End Method

export const get_brand = createAsyncThunk("product/get_brand", async (_, { fulfillWithValue, rejectWithValue }) => {
  try {
    const { data } = await api.get("/home/get-brands");
    // console.log(data)
    return fulfillWithValue(data);
  } catch (error) {
    if (process.env.NODE_ENV === "development") console.log(error.respone);
    return rejectWithValue(error);
  }
});
// End Method

export const get_color = createAsyncThunk("product/get_color", async (_, { fulfillWithValue, rejectWithValue }) => {
  try {
    const { data } = await api.get("/home/get-colors");
    // console.log(data)
    return fulfillWithValue(data);
  } catch (error) {
    if (process.env.NODE_ENV === "development") console.log(error.respone);
    return rejectWithValue(error);
  }
});
// End Method

export const customer_review = createAsyncThunk("review/customer_review", async (info, { fulfillWithValue, rejectWithValue }) => {
  try {
    const { data } = await api.post("/home/customer/submit-review", info);

    return fulfillWithValue(data);
  } catch (error) {
    if (process.env.NODE_ENV === "development") console.log(error.respone);
    return rejectWithValue(error);
  }
});
// End Method

//para
export const get_products = createAsyncThunk("product/get_products", async (_, { fulfillWithValue, rejectWithValue }) => {
  try {
    const { data } = await api.get("/home/get-products");
    if (process.env.NODE_ENV === "development") console.log(data);
    return fulfillWithValue(data);
  } catch (error) {
    if (process.env.NODE_ENV === "development") console.log(error.respone);
    return rejectWithValue(error);
  }
});
// End Method

export const price_range_product = createAsyncThunk("product/price_range_product", async (_, { fulfillWithValue, rejectWithValue }) => {
  try {
    const { data } = await api.get("/home/price-range-latest-product");
    if (process.env.NODE_ENV === "development") console.log(data);
    return fulfillWithValue(data);
  } catch (error) {
    console.log(error.respone);
    return rejectWithValue(error);
  }
});
// End Method

const appendQueryValue = (params, key, value) => {
  if (Array.isArray(value)) {
    value.filter(Boolean).forEach(item => params.append(key, item));
    return;
  }

  if (value !== undefined && value !== null && value !== "") {
    params.set(key, value);
  }
};

const buildProductQueryParams = query => {
  const params = new URLSearchParams();

  appendQueryValue(params, "category", query.category);
  appendQueryValue(params, "typeproduct", query.typeproduct);
  appendQueryValue(params, "typearticle", query.typearticle);
  appendQueryValue(params, "brand", query.brand);
  appendQueryValue(params, "color", query.color);
  appendQueryValue(params, "size", query.size);
  appendQueryValue(params, "rating", query.rating);
  appendQueryValue(params, "lowPrice", query.low);
  appendQueryValue(params, "highPrice", query.high);
  appendQueryValue(params, "sortPrice", query.sortPrice);
  appendQueryValue(params, "pageNumber", query.pageNumber);
  appendQueryValue(params, "searchValue", query.searchValue);
  appendQueryValue(params, "onlyDiscount", query.onlyDiscount);

  return params.toString();
};

const buildFacetQueryParams = query => {
  const params = new URLSearchParams();

  appendQueryValue(params, "category", query.category);
  appendQueryValue(params, "typeproduct", query.typeproduct);
  appendQueryValue(params, "typearticle", query.typearticle);
  appendQueryValue(params, "brand", query.brand);

  return params.toString();
};

export const query_products = createAsyncThunk("product/query_products", async (query, { dispatch, fulfillWithValue, rejectWithValue }) => {
  try {
    const { data } = await api.get(`/home/query-products?${buildProductQueryParams(query)}`);

    // Actualizar facetas automáticamente (tallas, marcas, etc.) cuando cambia la categoría o filtros principales
    if (query.pageNumber === 1) {
      dispatch(get_filtered_facets(query));
    }

    return fulfillWithValue(data);
  } catch (error) {
    console.log(error.respone);
    return rejectWithValue(error);
  }
});
// End Method

export const query_ofertas = createAsyncThunk("product/query_ofertas", async (query, { dispatch, fulfillWithValue, rejectWithValue }) => {
  try {
    const { data } = await api.get(`/home/query-products?${buildProductQueryParams({ ...query, onlyDiscount: "true" })}`);

    if (query.pageNumber === 1) {
      dispatch(get_filtered_facets(query));
    }

    return fulfillWithValue(data);
  } catch (error) {
    console.log(error.respone);
    return rejectWithValue(error);
  }
});
// End Method

export const product_details = createAsyncThunk("product/product_details", async (slug, { fulfillWithValue, rejectWithValue }) => {
  try {
    const { data } = await api.get(`/home/product-details/${slug}`);
    if (process.env.NODE_ENV === "development") console.log("product-details-", slug, data);
    return fulfillWithValue(data);
  } catch (error) {
    if (process.env.NODE_ENV === "development") console.log(error.respone);
    return rejectWithValue(error);
  }
});
// End Method

export const get_size = createAsyncThunk("product/get_size", async (_, { fulfillWithValue, rejectWithValue }) => {
  try {
    const { data } = await api.get("/home/get-sizes");
    return fulfillWithValue(data);
  } catch (error) {
    if (process.env.NODE_ENV === "development") console.log(error.respone);
    return rejectWithValue(error);
  }
});
// End Method

export const get_sizes_by_typearticle = createAsyncThunk("product/get_sizes_by_typearticle", async (typearticle, { fulfillWithValue, rejectWithValue }) => {
  try {
    const { data } = await api.get(`/size-by-typearticle/${typearticle}`);
    return fulfillWithValue(data);
  } catch (error) {
    if (process.env.NODE_ENV === "development") console.log(error.response);
    return rejectWithValue(error);
  }
});
// End Method

export const get_reviews = createAsyncThunk("review/get_reviews", async ({ productId, pageNumber }, { fulfillWithValue, rejectWithValue }) => {
  try {
    const { data } = await api.get(`/home/customer/get-reviews/${productId}?pageNo=${pageNumber}`);
    //  console.log(data)
    return fulfillWithValue(data);
  } catch (error) {
    if (process.env.NODE_ENV === "development") console.log(error.respone);
    return rejectWithValue(error);
  }
});
// End Method

export const get_banners = createAsyncThunk("banner/get_banners", async (_, { fulfillWithValue, rejectWithValue }) => {
  try {
    const { data } = await api.get(`/banners`);

    return fulfillWithValue(data);
  } catch (error) {
    if (process.env.NODE_ENV === "development") console.log(error.respone);
    return rejectWithValue(error);
  }
});
// End Method

// Obtener opciones de filtros disponibles según la selección actual (Facetas)
export const get_filtered_facets = createAsyncThunk("product/get_facets", async (query, { fulfillWithValue, rejectWithValue }) => {
  try {
    const { data } = await api.get(`/home/get-facets?${buildFacetQueryParams(query)}`);
    return fulfillWithValue(data);
  } catch (error) {
    return rejectWithValue(error.response?.data);
  }
});
// End Method

// Agrega esta acción después de tus otras acciones existentes
export const get_brand_by_name = createAsyncThunk("product/get_brand_by_name", async (brandName, { fulfillWithValue, rejectWithValue }) => {
  try {
    //http://localhost:5000/api/brand-get/ADIDAS
    const { data } = await api.get(`/brand-get/${brandName}`);
    return fulfillWithValue(data);
  } catch (error) {
    console.log(error.response);
    return rejectWithValue(error.response?.data);
  }
});
// End Method

export const homeReducer = createSlice({
  name: "home",
  initialState: {
    categorys: [],
    categorys_loading: false,
    facets_loading: false,

    typeproducts: [],
    typearticles: [],
    brands: [],
    colors: [],
    sizes: [],
    sizesByCategory: [],
    availableCategories: [], 
    availableBrands: [],
    availableTypeArticles: [],
    availableColors: [],
    availableSizes: [], // ✅ Tallas dinámicas según selección

    products: [],
    totalProduct: 0,
    parPage: 3,
    latest_product: [],
    topRated_product: [],
    discount_product: [],
    topRequest_product: [],
    priceRange: {
      low: 0,
      high: 100,
    },
    product: {},
    relatedProducts: [],
    moreProducts: [],
    errorMessage: "",
    successMessage: "",
    totalReview: 0,
    rating_review: [],
    reviews: [],
    banners: [],
    brandDetails: null,
    brandLoading: false,
    ofertaProducts: [],
    totalOfertas: 0,
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
    clearBrandDetails: state => {
      // ✅ Nuevo nombre
      state.brandDetails = null;
    },
    reset_facets: state => {
      // Devolver los filtros disponibles a su estado inicial (vacíos)
      state.availableCategories = [];
      state.availableBrands = [];
      state.availableTypeArticles = [];
      state.availableColors = [];
      state.availableSizes = [];
    },
  },
  extraReducers: builder => {
    builder
      .addCase(get_category.pending, (state, _) => {
        state.categorys_loading = true;
      })
      .addCase(get_category.fulfilled, (state, { payload }) => {
        state.categorys = payload.categorys;
        state.categorys_loading = false;
      })
      .addCase(get_category.rejected, (state, _) => {
        state.categorys_loading = false;
      })

      .addCase(get_typeproduct.fulfilled, (state, { payload }) => {
        state.typeproducts = payload.typeproducts;
      })
      .addCase(get_typearticle.fulfilled, (state, { payload }) => {
        state.typearticles = payload.typearticles;
      })
      .addCase(get_brand.fulfilled, (state, { payload }) => {
        state.brands = payload.brands;
      })
      .addCase(get_color.fulfilled, (state, { payload }) => {
        state.colors = payload.colors;
      })
      .addCase(get_size.fulfilled, (state, { payload }) => {
        state.sizes = payload.sizes;
      })
      .addCase(get_sizes_by_typearticle.fulfilled, (state, { payload }) => {
        state.sizesByCategory = payload.sizes;
      })

      .addCase(get_products.fulfilled, (state, { payload }) => {
        state.products = payload.products;
        state.latest_product = payload.latest_product;
        state.topRated_product = payload.topRated_product;
        state.discount_product = payload.discount_product;
        state.topRequest_product = payload.topRequest_product;
      })
      .addCase(price_range_product.fulfilled, (state, { payload }) => {
        state.latest_product = payload.latest_product;
        state.priceRange = payload.priceRange;
      })
      .addCase(query_products.fulfilled, (state, { payload }) => {
        if (payload.pageNumber > 1) {
          state.products = [...state.products, ...payload.products];
        } else {
          state.products = payload.products;
        }
        state.totalProduct = payload.totalProduct;
        state.parPage = payload.parPage;
      })

      .addCase(query_ofertas.fulfilled, (state, { payload }) => {
        if (payload.pageNumber > 1) {
          state.ofertaProducts = [...state.ofertaProducts, ...payload.products];
        } else {
          state.ofertaProducts = payload.products;
        }
        state.totalOfertas = payload.totalProduct;
      })

      .addCase(product_details.fulfilled, (state, { payload }) => {
        state.product = payload.product;
        state.relatedProducts = payload.relatedProducts;
        state.moreProducts = payload.moreProducts;
      })

      .addCase(customer_review.fulfilled, (state, { payload }) => {
        state.successMessage = payload.message;
      })

      .addCase(get_reviews.fulfilled, (state, { payload }) => {
        state.reviews = payload.reviews;
        state.totalReview = payload.totalReview;
        state.rating_review = payload.rating_review;
      })

      .addCase(get_banners.fulfilled, (state, { payload }) => {
        state.banners = payload.banners;
      })

      // Actualizar filtros disponibles según la selección del usuario
      .addCase(get_filtered_facets.pending, (state) => {
        state.facets_loading = true;
      })
      .addCase(get_filtered_facets.fulfilled, (state, { payload }) => {
        state.availableCategories = payload.categorys;
        state.availableBrands = payload.brands;
        state.availableTypeArticles = payload.typearticles;
        state.availableColors = payload.colors;
        state.availableSizes = payload.sizes;
        state.facets_loading = false;
      })
      .addCase(get_filtered_facets.rejected, (state) => {
        state.facets_loading = false;
      })

      // En extraReducers, actualiza los casos:
      .addCase(get_brand_by_name.pending, state => {
        state.brandLoading = true;
        state.errorMessage = "";
      })
      .addCase(get_brand_by_name.fulfilled, (state, { payload }) => {
        state.brandLoading = false;
        state.brandDetails = payload.brand; // ✅ Cambiado a brandDetails
      })
      .addCase(get_brand_by_name.rejected, (state, { payload }) => {
        state.brandLoading = false;
        state.errorMessage = payload?.error || "Error al cargar la marca";
        state.brandDetails = null; // ✅ Cambiado a brandDetails
      });
  },
});
export const { 
  messageClear, 
  clearBrandDetails, 
  reset_facets 
} = homeReducer.actions;
export default homeReducer.reducer;
